// Đợt Offline-3 — Màn fallback cho trang/section CHƯA có dữ liệu offline.
// Luôn có nút Quay lại (yêu cầu user) + nút Thử lại tuỳ chọn.
import { useNavigate } from "react-router-dom";
import { WifiOff, ArrowLeft, RotateCw } from "lucide-react";

export const OfflineFallback = ({
  title = "Trang này chưa có bản lưu ngoại tuyến",
  description = "Kết nối mạng để xem nội dung này. Các trang bạn đã mở gần đây vẫn xem được khi offline.",
  onRetry,
  compact = false,
}) => {
  const navigate = useNavigate();
  return (
    <div
      data-testid="offline-fallback"
      className={`flex flex-col items-center justify-center gap-4 text-center px-6 ${compact ? "py-10" : "min-h-[60vh]"}`}
    >
      <div className="w-14 h-14 rounded-full bg-amber-500/10 border border-amber-400/30 flex items-center justify-center">
        <WifiOff className="w-6 h-6 text-amber-300" />
      </div>
      <p className="text-sm font-bold text-white/90">{title}</p>
      <p className="text-xs text-white/55 max-w-sm leading-relaxed">{description}</p>
      <div className="flex items-center gap-3">
        <button
          type="button"
          data-testid="offline-fallback-back-btn"
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/8 border border-white/15 text-white/85 text-sm font-bold hover:bg-white/15 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Quay lại
        </button>
        {onRetry ? (
          <button
            type="button"
            data-testid="offline-fallback-retry-btn"
            onClick={onRetry}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-emerald-500/15 border border-emerald-400/40 text-emerald-300 text-sm font-bold hover:bg-emerald-500/25 transition-colors"
          >
            <RotateCw className="w-4 h-4" /> Thử lại
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default OfflineFallback;
